import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { WHATSAPP_CHAT_URL } from '../../../config/contactLinks';
import heroMainImage from '../../../assets/images/hero-main.jpg';
import heroSecondaryImage from '../../../assets/images/hero-secondary.jpg';

const stats = [
  { value: '500+', label: 'Tamamlanan Proje' },
  { value: '5+', label: 'Yıllık Deneyim' },
  { value: '%100', label: 'Müşteri Memnuniyeti' },
  { value: '11', label: 'Hizmet Çeşidi' },
];

export default function Hero() {
  return (
    <section id="anasayfa" className="pt-[123px] overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #f0f3fb 0%, #fafbff 50%, #fff8f0 100%)' }}>

      {/* Dot grid overlay */}
      <div className="absolute inset-0 pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(circle, #1a2b5e0d 1px, transparent 1px)', backgroundSize: '28px 28px' }} />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 pt-14 pb-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">

          {/* Left — Text */}
          <div className="flex-1 lg:max-w-[520px]">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center gap-2 bg-navy text-gold px-4 py-2 rounded-lg text-[11px] font-bold uppercase tracking-[0.18em] mb-8"
            >
              <i className="ri-map-pin-2-line text-xs"></i>
              NiğPak Temizlik &mdash; Niğde Merkez
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.65, delay: 0.1 }}
              className="text-[52px] md:text-[64px] lg:text-[72px] font-extrabold text-navy leading-[1.02] tracking-tight mb-6"
            >
              Pırıl Pırıl<br />
              <span className="relative inline-block text-gold">
                Temiz,
                <motion.span
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                  style={{ originX: 0 }}
                  className="absolute -bottom-1 left-0 right-0 h-[3px] bg-gold/30 rounded-full block"
                />
              </span>
              <br />Garantili<br />Hizmet.
            </motion.h1>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="flex items-center gap-3 mb-6"
            >
              <div className="w-10 h-[2px] bg-gold rounded-full" />
              <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-navy/50">
                Temizlikte Doğru Tercih
              </span>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.35 }}
              className="text-gray-500 text-[15px] leading-[1.8] mb-9 max-w-md"
            >
              Niğde&apos;de konut, ofis, villa ve ticari alanlar için profesyonel temizlik
              çözümleri sunuyoruz. Deneyimli ekip, uzman ekipman, söz verilen sonuçlar.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.45 }}
              className="flex flex-col sm:flex-row gap-3 mb-10"
            >
              <Link to="/hizmetler"
                className="bg-navy hover:bg-gold text-white font-bold px-7 py-4 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer text-center">
                Hizmetleri Keşfedin
              </Link>
              <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
                className="flex items-center justify-center gap-2 bg-white border border-gray-200 hover:border-gold hover:text-gold text-navy font-bold px-7 py-4 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-whatsapp-line text-[#25D366] text-base"></i>
                0543 191 0851
              </a>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.55 }}
              className="flex items-center gap-5 flex-wrap"
            >
              <div className="flex items-center gap-1">
                {[1,2,3,4,5].map(i => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-gold text-sm"></i>
                  </span>
                ))}
                <span className="text-navy text-xs font-extrabold ml-1.5">5.0</span>
              </div>
              <div className="w-px h-4 bg-gray-200" />
              <span className="text-gray-400 text-xs font-medium">500+ Memnun Müşteri</span>
              <div className="w-px h-4 bg-gray-200" />
              <span className="text-gray-400 text-xs font-medium">Sigortalı Ekip</span>
            </motion.div>
          </div>

          {/* Right — Stacked image layout */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.75, delay: 0.2 }}
            className="w-full lg:w-[50%] shrink-0 relative pb-10 pt-4 hidden lg:block"
          >
            <div className="absolute top-0 right-0 w-[88%] h-[92%] bg-navy/5 rounded-3xl -z-10" />

            <div className="relative rounded-2xl overflow-hidden ml-8" style={{ aspectRatio: '4/3' }}>
              <img
                src={heroMainImage}
                alt="NiğPak Temizlik hizmet örneği"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-navy/10 to-transparent pointer-events-none" />
            </div>

            <div className="absolute bottom-4 left-0 w-44 rounded-xl overflow-hidden border-4 border-white">
              <img
                src={heroSecondaryImage}
                alt="Cam temizliği"
                className="w-full h-28 object-cover object-top"
              />
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.55 }}
              className="absolute top-8 -right-2 bg-gold text-white rounded-xl px-4 py-3"
            >
              <div className="flex items-center gap-2">
                <span className="w-7 h-7 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-award-fill text-sm"></i>
                </span>
                <div>
                  <p className="font-extrabold text-sm leading-none">Niğde #1</p>
                  <p className="text-white/80 text-[10px] mt-0.5">Temizlik Firması</p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.7 }}
              className="absolute bottom-14 right-0 bg-white border border-gray-100 rounded-xl px-4 py-3"
            >
              <div className="flex items-center gap-2">
                <span className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-green-500 text-base"></i>
                </span>
                <div>
                  <p className="text-navy font-extrabold text-xs leading-none">Sigortalı Ekip</p>
                  <p className="text-gray-400 text-[10px] mt-0.5">Güvenli Hizmet</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Mobile image */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="w-full lg:hidden relative"
          >
            <div className="relative rounded-2xl overflow-hidden w-full" style={{ height: '260px' }}>
              <img
                src={heroMainImage}
                alt="NiğPak Temizlik hizmet örneği"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-navy/10 to-transparent pointer-events-none" />
            </div>

            {/* Floating badge — Niğde #1 */}
            <div className="absolute top-4 right-4 bg-gold text-white rounded-xl px-3 py-2 shadow-md">
              <div className="flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-lg">
                  <i className="ri-award-fill text-xs"></i>
                </span>
                <div>
                  <p className="font-extrabold text-xs leading-none">Niğde #1</p>
                  <p className="text-white/80 text-[9px] mt-0.5">Temizlik Firması</p>
                </div>
              </div>
            </div>

            {/* Floating badge — Sigortalı */}
            <div className="absolute bottom-4 left-4 bg-white border border-gray-100 rounded-xl px-3 py-2 shadow-md">
              <div className="flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center bg-green-50 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-green-500 text-sm"></i>
                </span>
                <div>
                  <p className="text-navy font-extrabold text-xs leading-none">Sigortalı Ekip</p>
                  <p className="text-gray-400 text-[9px] mt-0.5">Güvenli Hizmet</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Stats strip */}
      <div className="relative mt-14 border-t border-gray-200/80 bg-white/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-100">
            {stats.map((s, i) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 + i * 0.1 }}
                className="py-6 flex flex-col items-center gap-1 group"
              >
                <div className="w-6 h-0.5 bg-gold rounded-full mb-2 group-hover:w-10 transition-all duration-300" />
                <div className="text-3xl md:text-4xl font-extrabold text-navy leading-none">{s.value}</div>
                <div className="text-gray-400 text-[11px] font-semibold uppercase tracking-[0.15em]">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
